import PropTypes from "prop-types";
import {Fragment, useRef} from "react";
import {Dialog, Transition} from "@headlessui/react";

// `afterLeave` fires once the dialog has fully left (200ms leave transition done,
// Dialog unmounted). While it is leaving, Headless UI still holds the focus trap
// and marks the rest of the page inert, so a parent that wants to move the focus
// somewhere after closing (e.g. back to the scan input) must wait for this —
// focusing on the `open → false` flip is a no-op that ends with nothing focused.
export const DialogView = ({open, setOpen, children, className="", allowOverflow=false, closeOnBackdrop=false, afterLeave=undefined, initialFocus=undefined}) => {

    DialogView.propTypes = {
        open: PropTypes.bool.isRequired,
        setOpen: PropTypes.func.isRequired,
        allowOverflow: PropTypes.bool,
        afterLeave: PropTypes.func,
        initialFocus: PropTypes.object,
    }

    const cancelButtonRef = useRef(null)

    return (
        <Transition.Root show={open} as={Fragment} afterLeave={afterLeave}>
            <Dialog
                as="div"
                static
                className="fixed z-10 inset-0"
                initialFocus={initialFocus || cancelButtonRef}
                open={open}
                onClose={() => closeOnBackdrop && setOpen(false)}
            >
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 ">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className={'inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:p-6 ' + (allowOverflow ? 'overflow-visible' : 'overflow-hidden') + className}>

                            {children}

                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
}